import getConfig from 'next/config';
import { envExperienceKey, envTechStackKey, envWorkKey } from '../common';
import { getContent, getTechData, getWorksData } from '../lib/contentLoader';

export const environmentVariables = {
  isDev: process.env.NEXT_PUBLIC_IS_DEV,
  isTechLinkVisible: process.env.NEXT_PUBLIC_TECH_LINK_IS_VISIBLE,
  aboutMeTextBefore: getContent('aboutMe').split("INDIA")[0],
  aboutMeTextAfter: getContent('aboutMe').split("INDIA")[1],
  design: getContent('design'),
  designDescription: getContent('designDescription'),
  figma: getContent('figma'),
  illustrator: getContent('illustrator'),
  webflow: getContent('webflow'),
  resume: getContent('resume'),
  projects: getContent('projects'),
  userName: getContent('username'),
  fullUserName: getContent('usernameFull'),
  work: getContent('work'),
  about: getContent('about'),
  tech: getContent('technology'),
  webDev: getContent('webDev'),
  webDevDescription: getContent('webDevDescription'),
  nextJs: getContent('nextjs'),
  tailwind: getContent('tailwind'),
  typescript: getContent('typescript'),
  experience: getContent('experience'),
  carrierStartYear: getContent('carrierStartYear'),
  yearsOfExperience: getContent('yearsOfExperience'),
  yearsOfExperienceDescription: getContent('yearsOfExperienceDescription'),
  getInTouch: getContent('getInTouch'),
  getInTouchDescription: getContent('getInTouchDescription'),
  works: getContent('worksLabel'),
  worksDescription: getContent('worksDescription'),
  developer: getContent('developer'),
  designer: getContent('designer'),
  weeb: getContent('weeb'),
  contact: getContent('contact'),
  gmail: getContent('gmail'),
  userGmail: getContent('userGmail'),
  linkedIn: getContent('linkedin'),
  instagram: getContent('instagram'),
  instagramAccount: getContent('instagramAccount'),
  dattebayo: getContent('dattebayo'),
  develop: getContent('develop'),
  anime: getContent('anime'),
  psychology: getContent('psychology'),
  techStack: getContent('techHeaderStack'),
  techStackDescription: getContent('techHeaderDescription'),
  techTitle: getContent('techHeaderTitle'),
  aboutTitle: getContent('aboutTitle'),
  workTitle: getContent('workTitle'),
  homeTitle: getContent('homeTitle'),
  shortInformation: getContent('shortInformation'),
  contactTitle: getContent('contactTitle'),
  name: getContent('name'),
  email: getContent('email'),
  message: getContent('message'),
  submit: getContent('submit'),
  githubRepo: getContent('githubRepo'),
  thankYouTitle: getContent('thankYouTitle'),
  thankYou: getContent('thankYou'),
  formSubmissionReceived: getContent('formSubmissionReceived'),
  content: getContent('content'),

  // RESUME
  resumeDesignation: getContent('resumeDesignation'),
  resumePersonalInfo: getContent('resumePersonalInfo'),
  resumeSkills: getContent('resumeSkills'),
  resumeExcellent: process.env.NEXT_PUBLIC_RESUME_EXCELLENT,
  resumeVeryGood: process.env.NEXT_PUBLIC_RESUME_VERY_GOOD,
  resumeAverage: process.env.NEXT_PUBLIC_RESUME_AVERAGE,
  resumeLeftSectionBackground: process.env.NEXT_PUBLIC_RESUME_LEFT_SECTION_BACKGROUND,
  resumeRoundedRectangleBarBackground: process.env.NEXT_PUBLIC_RESUME_ROUNDED_RECTANGLE_BAR_BACKGROUND,
  resumeRoundedRectangleProficiencyBarBackground: process.env.NEXT_PUBLIC_RESUME_ROUNDED_RECTANGLE_PROFICIENCY_BAR_BACKGROUND,
  resumeOtherSkill: process.env.NEXT_PUBLIC_RESUME_OTHER_SKILL,
  resumeLanguage: process.env.NEXT_PUBLIC_RESUME_LANGUAGE,
  resumeSocialPresence: process.env.NEXT_PUBLIC_RESUME_SOCIAL_PRESENCE,
  resumeProfessionalExperience: process.env.NEXT_PUBLIC_RESUME_PROFESSIONAL_EXPERIENCE,
  resumeEducation: process.env.NEXT_PUBLIC_RESUME_EDUCATION,

  techData: getTechData(),

  resumeSocialPresences: (() => {
    const socialPresences = {};
    let index = 1; // start at 1 because your env variables start at 1

    while (true) {
      const key = process.env[`NEXT_PUBLIC_RESUME_SOCIAL_PRESENCE_${index}`];
      const value = process.env[`NEXT_PUBLIC_RESUME_SOCIAL_PRESENCE_${index}_INFO`];

      if (!key || !value) {
        break;
      }

      socialPresences[`${key}:`] = value;
      index++;
    }

    return socialPresences;
  })(),

  resumeAboutInfos: (() => {
    const aboutInfos = [];
    let index = 1; // start at 1 because your env variables start at 1

    while (true) {
      const value = process.env[`NEXT_PUBLIC_RESUME_ABOUT_INFO_${index}`];

      if (!value) {
        break;
      }

      aboutInfos.push(value);
      index++;
    }

    return aboutInfos;
  })(),

  resumeLanguages: (() => {
    const languages = [];
    let index = 1; // start at 1 because your env variables start at 1

    while (true) {
      const language = process.env[`NEXT_PUBLIC_RESUME_LANGUAGE_${index}`];
      const proficiency = process.env[`NEXT_PUBLIC_RESUME_LANGUAGE_${index}_PROFICIENCY`];
      const label = process.env[`NEXT_PUBLIC_RESUME_LANGUAGE_${index}_LABEL`];

      if (!language || !proficiency || !label) {
        break;
      }

      languages.push({
        language,
        proficiency,
        label
      });
      index++;
    }

    return languages;
  })(),

  resumeOtherSkills: (() => {
    const skills = [];
    let index = 1; // start at 1 because your env variables start at 1

    while (true) {
      const skill = process.env[`NEXT_PUBLIC_RESUME_OTHER_SKILL_${index}`];

      if (!skill) {
        break;
      }

      skills.push(skill);
      index++;
    }

    return skills;
  })(),

  resumeSkillsList: (() => {
    const skillsList = [];
    let index = 1; // start at 1 because your env variables start at 1

    while (true) {
      const skill = process.env[`NEXT_PUBLIC_RESUME_SKILLS_${index}`];
      const proficiency = process.env[`NEXT_PUBLIC_RESUME_SKILLS_${index}_PROFICIENCY`];
      const label = process.env[`NEXT_PUBLIC_RESUME_SKILLS_${index}_LABEL`];

      if (!skill || !proficiency || !label) {
        break;
      }

      skillsList.push({
        skill,
        proficiency,
        label
      });
      index++;
    }

    return skillsList;
  })(),

  resumePersonalInfos: (() => {
    const personalInfos = {};
    let index = 1; // start at 1 as your env variables start at 1

    while (true) {
      const infoKey = process.env[`NEXT_PUBLIC_RESUME_PERSONAL_INFO_${index}`];
      const infoVal = process.env[`NEXT_PUBLIC_RESUME_PERSONAL_INFO_${index}_VAL`];

      if (!infoKey || !infoVal) {
        break;
      }

      personalInfos[`${infoKey}:`] = infoVal;
      index++;
    }

    return personalInfos;
  })(),

  getPageExperienceData: (() => {
    const experienceData = [];
    let index = 1; // starting from 1 as per your env format

    while (true) {
      const duration = process.env[`NEXT_PUBLIC_RESUME_PAGE_1_EXP_DURATION_${index}`];
      const position = process.env[`NEXT_PUBLIC_RESUME_PAGE_1_EXP_POSITION_${index}`];

      if (!duration || !position) {
        break;
      }

      const experience = {
        duration,
        position,
        projects: []
      };

      let projectIndex = 1; // inner loop for projects
      while (true) {
        const projectName = process.env[`NEXT_PUBLIC_RESUME_PAGE_1_EXP_PROJECT_${index}_NAME_${projectIndex}`];
        const projectDesc = process.env[`NEXT_PUBLIC_RESUME_PAGE_1_EXP_PROJECT_${index}_DESC_${projectIndex}`];

        if (!projectName || !projectDesc) {
          break;
        }

        const project = {
          name: projectName,
          description: projectDesc,
          responsibilities: []
        };

        let respIndex = 1; // inner loop for responsibilities
        while (true) {
          const responsibility = process.env[`NEXT_PUBLIC_RESUME_PAGE_1_EXP_PROJECT_${index}_DESC_${projectIndex}_RESP_${respIndex}`];

          if (!responsibility) {
            break;
          }

          project.responsibilities.push(responsibility);
          respIndex++;
        }

        experience.projects.push(project);
        projectIndex++;
      }

      experienceData.push(experience);
      index++;
    }

    return experienceData;
  })(),

  getEducationData: (() => {
    const educationData = [];
    let index = 1; // starting from 1 as per your env format

    while (true) {
      const year = process.env[`NEXT_PUBLIC_RESUME_EDUCATION_YEAR_${index}`];
      const course = process.env[`NEXT_PUBLIC_RESUME_EDUCATION_COURSE_${index}`];
      const academy = process.env[`NEXT_PUBLIC_RESUME_EDUCATION_ACADEMY_${index}`];

      if (!year || !course || !academy) {
        break;
      }

      const education = {
        year,
        course,
        academy
      };

      educationData.push(education);
      index++;
    }

    return educationData;
  })(),

  getWorkData: getWorksData(),  

  // Footer
  linkedInUrl: process.env.NEXT_PUBLIC_LINKEDIN_URL,
  githubUrl: process.env.NEXT_PUBLIC_GITHUB_URL,
  gmailUrl: process.env.NEXT_PUBLIC_GMAIL_URL,
  githubPortfolio: process.env.NEXT_PUBLIC_GITHUB_PORTFOLIO,
  instagramUrl: process.env.NEXT_PUBLIC_INSTAGRAM_URL,

  getExperienceData: (() => {
    const { publicRuntimeConfig } = getConfig(); // assuming you're using next/config
    let sequence;

    if (process.env.NEXT_PUBLIC_EXPERIENCE_SEQ) {
      sequence = process.env.NEXT_PUBLIC_EXPERIENCE_SEQ.split(',').map(Number);
    }

    const data = [];

    function getExperienceFromEnv(index) {
      const experienceData = {};

      experienceData.title = publicRuntimeConfig[`NEXT_PUBLIC_EXPERIENCE_${index}_TITLE`];
      experienceData.description = publicRuntimeConfig[`NEXT_PUBLIC_EXPERIENCE_${index}_DESCRIPTION`];
      experienceData.image = publicRuntimeConfig[`NEXT_PUBLIC_EXPERIENCE_${index}_IMAGE`];

      // Extracting tags into an array
      const tags = publicRuntimeConfig[`NEXT_PUBLIC_EXPERIENCE_${index}_TAG`];
      if (tags) {
        // Assuming tags are stored as a string representation of an array
        try {
          experienceData.tags = JSON.parse(tags);
        } catch (e) {
          console.error('Error parsing tags for experience', index, e);
          experienceData.tags = []; // default to an empty array in case of an error
        }
      } else {
        experienceData.tags = [];
      }

      if (!experienceData.title) {
        return null;
      }

      return experienceData;
    }

    if (sequence) {
      sequence.forEach((id) => {
        const experience = getExperienceFromEnv(id);
        if (experience) {
          data.push(experience);
        }
      });
    } else {
      let index = 1;
      while (true) {
        const experience = getExperienceFromEnv(index);
        if (experience) {
          data.push(experience);
          index++;
        } else {
          break;
        }
      }
    }

    return data;
  })(),

  // About
  aboutCategory: (() => {
    try {
      // Assuming the environment variable is a string that looks like a JSON array
      const categoryStr = process.env.NEXT_PUBLIC_ABOUT_CATEGORY;
      return JSON.parse(categoryStr);
    } catch (e) {
      console.error('Error parsing about category:', e);
      return []; // Default to an empty array in case of an error
    }
  })(),
  aboutDescription: process.env.NEXT_PUBLIC_ABOUT_DESCRIPTION,
  aboutContactDescription: process.env.NEXT_PUBLIC_ABOUT_CONTACT_DESCRIPTION,
};
